import { categoryBrowsePath, subcategoryBrowsePath } from './categoryPaths';
import { subcategorySlug } from './categorySlug';

let cachePromise = null;
/** @type {Array<{ slug: string, name: string, subcategories?: Array<{ name: string, slug?: string }> }> | null} */
let cachedCategories = null;

export function preloadBrowseCategories() {
  if (!cachePromise) {
    cachePromise = fetch('/api/landing-categories.php')
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('categories'))))
      .then((data) => {
        cachedCategories = Array.isArray(data?.categories) ? data.categories : [];
        return cachedCategories;
      })
      .catch(() => {
        cachedCategories = [];
        return [];
      });
  }
  return cachePromise;
}

function normalizeBrowseName(name) {
  return typeof name === 'string' ? name.trim().toLocaleLowerCase('en') : '';
}

/** Exact category/subcategory name match when submitting the search box. */
export function findExactBrowsePath(query) {
  const q = normalizeBrowseName(query);
  if (!q || !cachedCategories) {
    return null;
  }

  for (const category of cachedCategories) {
    for (const sub of category.subcategories ?? []) {
      if (normalizeBrowseName(sub.name) === q) {
        return subcategoryBrowsePath(category.slug, subcategorySlug(sub));
      }
    }
  }

  for (const category of cachedCategories) {
    if (normalizeBrowseName(category.name) === q) {
      return categoryBrowsePath(category.slug);
    }
  }

  return null;
}

export function browsePathFromSuggestion(suggestion) {
  if (!suggestion || typeof suggestion !== 'object') {
    return null;
  }
  if (suggestion.kind === 'subcategory') {
    return subcategoryBrowsePath(suggestion.categorySlug, suggestion.subcategorySlug);
  }
  if (suggestion.kind === 'category') {
    return categoryBrowsePath(suggestion.categorySlug);
  }
  return null;
}

export function isBrowseSuggestion(suggestion) {
  return suggestion?.kind === 'category' || suggestion?.kind === 'subcategory';
}
